import { AuthorityType } from 'interfaces';
import { VALID_ROLES } from 'const';

export const checkPermission = (authorities: AuthorityType[]): boolean => {
  return authorities.some((role) =>
    VALID_ROLES.some((validRole) => role === validRole)
  );
};
